module.exports = __webpack_public_path__ + "static/media/1350_popup_Exit_Medical_all.e9664ef6.png";